// dropdown views
export const DROPDOWN_VIEWS = {
    CHOICE_LIST: 'CHOICE_LIST',
};

// overlay views
export const OVERLAY_VIEWS = {
    ERROR_VIEW: 'ERROR_VIEW',
    CONFIRM_VIEW: 'CONFIRM_VIEW',
    SUCCESS_VIEW: 'SUCESS_VIEW',
    PROMPT_VIEW: 'PROMPT_VIEW',
    SET_DRUG_PREFERENCE: 'SET_DRUG_PREFERENCE',
    DISABLE_AUTO_REFILL: 'DISABLE_AUTO_REFILL',
    CHANGE_DEFAULT_CONFIRM: 'CHANGE_DEFAULT_CONFIRM',
    PRIOR_AUTHORIZATION: 'PRIOR_AUTHORIZATION',
    OUTBOUND_CALLS: 'OUTBOUND_CALLS',
    WEBSITE_ISSUES: 'WEBSITE_ISSUES',
    ADD_EDIT_CONTACTS: 'ADD_EDIT_CONTACTS',
    EDIT_ADMIN_CONTACTS: 'EDIT_ADMIN_CONTACTS',
    EDIT_SPLASH_PAGE_CONTENT: 'EDIT_SPLASH_PAGE_CONTENT',
    ADD_EDIT_ADDRESS: 'ADD_EDIT_ADDRESS',
    ADD_EDIT_ALLERGIES: 'ADD_EDIT_ALLERGIES',
    EDIT_SECURITY_SETTING: 'EDIT_SECURITY_SETTING',
    EDIT_PASSWORD_SECURITY_SETTING: 'EDIT_PASSWORD_SECURITY_SETTING',
    SECURITY_SETTING_SEND_OTP: 'SECURITY_SETTING_SEND_OTP',
    ALTERNATE_DRUGS: 'ALTERNATE_DRUGS',
    PAY_BALANCE_STEPS: 'PAY_BALANCE_STEPS',
    IMPERSONATE_MEMBER: 'IMPERSONATE_MEMBER',
    MARK_RESOLVED: 'MARK_RESOLVED',
    CAPTURE_REASON_CANCEL_ORDER: 'CAPTURE_REASON_CANCEL_ORDER',
    CSR_MEMBER_NOTES: 'CSR_MEMBER_NOTES',
    CSR_ORDER_NOTES: 'CSR_ORDER_NOTES',
    CSR_ORDER_LINE_NOTES: 'CSR_ORDER_LINE_NOTES',
    SUBMIT_AUTH_EPOST_ID: 'SUBMIT_AUTH_EPOST_ID',
    CAG_FILTER: 'CAG_FILTER',
    NOTIFICATION_VIEW: 'NOTIFICATION_VIEW',
    DEACTIVATE_EPOST: 'DEACTIVATE_EPOST',
    REACTIVATE_EPOST: 'REACTIVATE_EPOST',
    CALL_MARK_RESOLVED: 'CALL_MARK_RESOLVED',
    CLAIM_TODO: 'CLAIM_TODO',
    MEMBER_BUSINESS_PROCESS: 'MEMBER_BUSINESS_PROCESS',
    MEMBER_SERVICES_ESCALATIONS: 'MEMBER_SERVICES_ESCALATIONS',
    VIEW_CASE: 'VIEW_CASE',
    TO_DO_PRESCRIPTION: 'TO_DO_PRESCRIPTION',
    MEMBER_ESCALATION_CALL: 'MEMBER_ESCALATION_CALL',
    MATERIAL_MAIL_OUT: 'MATERIAL_MAIL_OUT',
    ORDER_TO_DO: 'ORDER_TO_DO',
    STATUS_OF_CLAIM: 'STATUS_OF_CLAIM',
    ADD_INSURANCE_DISCOUNT_CARD: 'ADD_INSURANCE_DISCOUNT_CARD',
    SET_PATIENT_NOTES: 'SET_PATIENT_NOTES',
    SET_PHONE_NUMBER: 'SET_PHONE_NUMBER',
    CHANGE_NEXT_REFILL_DATE: 'CHANGE_NEXT_REFILL_DATE',
    CMS_WIDGET: 'CMS_WIDGET',
    CONTROLLED_DRUG_REORDER: 'CONTROLLED_DRUG_REORDER',
    WELL_CONNECT_OPT_IN: 'WELL_CONNECT_OPT_IN',
    EDIT_WELL_CONNECT_PHONE: 'EDIT_WELL_CONNECT_PHONE',
    PAYMENT_CARD_ACTIVATION: 'PAYMENT_CARD_ACTIVATION',
    PERSONAL_ID_WIDGET: 'PERSONAL_ID_WIDGET',
    SERVICE_NOW: 'SERVICE_NOW',
    SERVICE_NOW_FORM: 'SERVICE_NOW_FORM',
    CONFIRMATION_PROMPT_WITH_ICON: 'CONFIRMATION_PROMPT_WITH_ICON',
    ERROR_NO_PERMISSIONS: 'ERROR_NO_PERMISSIONS',
    LANGUAGE_PREFERENCE: 'LANGUAGE_PREFERENCE',
    IVR_GET_PIN: 'IVR_GET_PIN',
    TRACKING_DETAILS_OVERLAY_VIEW: 'TRACKING_DETAILS_OVERLAY_VIEW',
    ADD_CREDIT_OVERLAY: 'ADD_CREDIT_OVERLAY'
    };
